import { useState } from 'react'
import { PayoutStatus } from '@ayub/shared'
import { BudgetPanel } from './BudgetPanel'
import { PayoutHistoryView } from './PayoutHistoryView'
import { usePayoutSummary } from './hooks'
import type { HistoryStatusFilter } from './hooks'
import { PayoutReadyView } from './PayoutReadyView'
import { PayoutRequestsView } from './PayoutRequestsView'
import { PayoutTabs } from './PayoutTabs'
import type { PayoutTab } from './PayoutTabs'

/**
 * Sahifa 4 — To'lovlar (`docs/03-app-flow.md`). Uch tab: So'rovlar / To'lovga tayyor / Tarix.
 * Har bir tab o'z holatini (sahifa raqami, tarix filtri) saqlaydi — tab almashganda
 * yo'qolib ketmasligi uchun state shu yerda, umumiy komponentda.
 */
export function PayoutsPage() {
  const [tab, setTab] = useState<PayoutTab>('requests')
  const [requestsPage, setRequestsPage] = useState(1)
  const [historyStatus, setHistoryStatus] = useState<HistoryStatusFilter>(PayoutStatus.PAID)
  const [historyPage, setHistoryPage] = useState(1)

  const { summary, isLoading: summaryLoading } = usePayoutSummary()

  function handleTabChange(next: PayoutTab) {
    setTab(next)
  }

  function handleHistoryStatusChange(next: HistoryStatusFilter) {
    setHistoryStatus(next)
    setHistoryPage(1)
  }

  return (
    <div className="flex flex-col gap-4">
      <header>
        <h1 className="text-xl font-semibold">To&apos;lovlar</h1>
      </header>

      <div className="mx-auto w-full max-w-5xl">
        <BudgetPanel />
      </div>

      <div className="mx-auto w-full max-w-5xl">
        <PayoutTabs
          value={tab}
          onChange={handleTabChange}
          requestsCount={summary?.pendingRequests}
          readyCount={summary?.readyBloggers}
          isLoading={summaryLoading}
        />
      </div>

      <div className="mx-auto w-full max-w-5xl">
        {tab === 'requests' && (
          <PayoutRequestsView page={requestsPage} onPageChange={setRequestsPage} />
        )}
        {tab === 'ready' && <PayoutReadyView />}
        {tab === 'history' && (
          <PayoutHistoryView
            status={historyStatus}
            onStatusChange={handleHistoryStatusChange}
            page={historyPage}
            onPageChange={setHistoryPage}
          />
        )}
      </div>
    </div>
  )
}
